export enum TernActions {
  INIT = "INIT",
  ADD_FILE = "ADD_FILE",
  DELETE_FILE = "DELETE_FILE",
  REQUEST = "REQUEST",
  DELETE_DEF = "DELETE_DEF",
  ADD_DEF = "ADD_DEF",
}
